import React from 'react';
import { CalendarCheckIcon, PhoneCallIcon, PlugZapIcon } from 'lucide-react';
import { steps } from '../data/content';
const icons = {
  plug: PlugZapIcon,
  phone: PhoneCallIcon,
  calendar: CalendarCheckIcon
};
export function HowItWorks() {
  return <section id="steps" aria-labelledby="steps-title" className="scroll-mt-20 border-b border-white/5 bg-ink-800" data-id="element-99" data-mp="3q0ky4mfd9snb">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-100" data-mp="ljrwjf0e6znz">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-101" data-mp="qjd60jd6uqey">
          The three steps
        </p>
        <h2 id="steps-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-102" data-mp="cshvl2n1k199">
          Connect, answer, book. Nothing your agents have to learn.
        </h2>

        <ol className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-103" data-mp="14humpx4of2nd">
          {steps.map(step => {
          const Icon = icons[step.icon];
          return <li key={step.number} className="rounded-xl border border-white/10 bg-ink-700 p-7" data-id="element-104" data-mp="2rkwgb5zkupql">
                <div className="flex items-center justify-between" data-id="element-105" data-mp="2mki55f2oizoc">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-106" data-mp="31c949mi98vrc">
                    <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-107" data-mp="2wio3jmpa1nog" />
                  </span>
                  <span className="font-display text-sm font-semibold tracking-widest text-white/25" data-id="element-108" data-mp="3ae8m2h13g3vc">
                    {step.number}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-xl font-semibold tracking-tight text-white" data-id="element-109" data-mp="3k9tmiaqikw2z">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-110" data-mp="1pvslpkbelz09">{step.body}</p>
              </li>;
        })}
        </ol>

        <p className="mt-10 max-w-3xl text-sm leading-relaxed text-white/55" data-id="element-111" data-mp="1kysh7du7d4b9">
          Book and log also covers the paperwork: a booked tour triggers your
          brokerage&rsquo;s buyer touring agreement for e-signature, with reminders until
          it is signed before the showing.
        </p>
        <p className="mt-4 max-w-2xl text-sm text-white/50" data-id="element-112" data-mp="3tylvkjaarj91">
          Every appointment we book is speed to lead you are already paying for. More
          buyer consults, more listing appointments, more GCI on the board.
        </p>
      </div>
    </section>;
}